<template>
  <div class="base-wizard">
    <div class="text-right">
      <b-button
        class="m-2"
        variant="tertiary"
        @click="cancel()"
        :disabled="cancelBtnIsDisabled"
      >
        <i
          class="fa-light  fa-x"
        />
      </b-button>
    </div>
    <b-nav
      pills
      justified
      class="thumbnail setup-panel"
    >
      <b-nav-item
        v-for="(tab, index) in tabs"
        :key="index"
        class="flex-column"
        :active="index === activeIndex"
      >
        <h4 class="list-group-item-heading">
          Step {{ index + 1 }}
        </h4>
        <p class="list-group-item-text">
          {{ tab.subtitle }}
        </p>
      </b-nav-item>
    </b-nav>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BaseWizard',

  props: {
    activeIndex: {
      type: Number,
      required: true,
    },
    tabs: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      cancelBtnIsDisabled: false,
    };
  },
  methods: {
    cancel() {
      this.$emit('close-modal');
    },
  },
};
</script>

<style lang="scss">

.base-wizard {
  max-height: 90vh;
  .nav-pills {
    background-color: #DCE4FA;
    position: relative;
    padding: 10px;

    .nav-item {
      background-color: #DCE4FA;
      margin: 0;
      cursor: default;
    }

    .nav-link {
      display: inline-block;
      color: #2A51C7;
      padding: 20px 15px;
      cursor: default;

      &.active {
        color: #fbfbff;
        background-color: #2A51C7;
      }
    }
  }
}
.list-group-item-text {
  margin-bottom: 0;
}
</style>
